var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGearWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 840,
    height: 840,
    viewBox: "0 0 840 840",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gear_wheel",
    "data-name": "gear wheel",
    d: "M551.213,357.867a144.162,144.162,0,1,1,14.244,203.378A144.228,144.228,0,0,1,551.213,357.867Zm-108.1-134.961a316.6,316.6,0,0,0-40.614,46.743l30.8,39.07A269.48,269.48,0,0,0,407.169,362.3l-49.764-.176a316.638,316.638,0,0,0-11.8,60.766l46.214,18.455a268.74,268.74,0,0,0,4.168,59.466L352.8,525.526a314.948,314.948,0,0,0,20.175,58.518l49.235-7.122a268.308,268.308,0,0,0,33.337,49.411L430.5,669.35a315.172,315.172,0,0,0,46.743,40.591l39.093-30.8a267.247,267.247,0,0,0,53.578,26.149l-.2,49.742a315.021,315.021,0,0,0,60.766,11.818l18.455-46.214a268.763,268.763,0,0,0,59.465-4.167l24.717,43.193a317.3,317.3,0,0,0,58.539-20.174l-7.143-49.235a269.309,269.309,0,0,0,49.433-33.36l43,25.047a315.145,315.145,0,0,0,40.614-46.721l-30.8-39.071a269.165,269.165,0,0,0,26.128-53.6l49.764.2a316.657,316.657,0,0,0,11.8-60.766l-46.215-18.455a268.749,268.749,0,0,0-4.167-59.465l43.194-24.717a315.724,315.724,0,0,0-20.175-58.54l-49.234,7.122A269.1,269.1,0,0,0,864.5,278.514l25.047-43A315.348,315.348,0,0,0,842.809,194.9l-39.07,30.8a267.928,267.928,0,0,0-53.6-26.128l.2-49.764a316.655,316.655,0,0,0-60.766-11.8l-18.455,46.214a267.474,267.474,0,0,0-59.466,4.167l-24.717-43.193a315.606,315.606,0,0,0-58.539,20.153l7.144,49.257a267.232,267.232,0,0,0-49.411,33.338Z",
    transform: "translate(297.862 -341.977) rotate(45)",
    fill: "#180275",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearWheel);
export default __webpack_public_path__ + "static/media/gear-wheel.3752f6beeaabee86ae3dbe0c951d4c2a.svg";
export { ForwardRef as ReactComponent };